import React, { Fragment } from 'react';
import {
  Dimmer,
  Box,
  Container,
  RouterNavLink,
  Flex,
  ExternalLink,
  Column,
  Row,
} from '../core';
import { ConnectWallet } from '../ConnectWallet';
import { ToggleMenu } from '../nav';
import { Github, Gitbook, Discord, Twitter } from '../icons';

export const MobileMenu = (): JSX.Element => {
  return (
    <Fragment>
      <Row sx={{ p: 3, justifyContent: 'space-between', alignItems: 'center' }}>
        <Dimmer />
        <ToggleMenu />
      </Row>
      <Container
        py={5}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Column sx={{ alignItems: 'center' }}>
          <RouterNavLink sx={{ fontSize: 4 }} exact to="/">
            Vaults
          </RouterNavLink>
          <Box my={3} />
          <ExternalLink sx={{ fontSize: 4 }} href="https://docs.scion.finance/">
            Docs
          </ExternalLink>
        </Column>
        <Box sx={{ width: '100%' }}>
          <Flex py={5} sx={{ justifyContent: 'center' }}>
            <ConnectWallet />
          </Flex>
          <Row pb={3} sx={{ justifyContent: 'center' }}>
            <ExternalLink
              sx={{ fontSize: 4 }}
              href="https://github.com/scion-finance/"
            >
              <Github />
            </ExternalLink>
            <Box mx={3} />
            <ExternalLink
              sx={{ fontSize: 4 }}
              href="https://twitter.com/scion_fi/"
            >
              <Twitter />
            </ExternalLink>
            <Box mx={3} />
            <ExternalLink
              sx={{ fontSize: 4 }}
              href="https://discord.gg/X8Hh3KYhAu"
            >
              <Discord />
            </ExternalLink>
            <Box mx={3} />
            <ExternalLink
              sx={{ fontSize: 4 }}
              href="https://docs.scion.finance/"
            >
              <Gitbook />
            </ExternalLink>
          </Row>
        </Box>
      </Container>
    </Fragment>
  );
};
